import { orderBy } from 'lodash';
import React, { useMemo } from 'react';

import { summaries as data } from 'main/changelog/summaries';
import TitleSection from 'pages/Landings/components/TitleSection';
import parseDate from 'utils/parse-date';

import Card from './components/Card';
import useStyles from './styles';

import Layout from '../components/Layout';

const Changelog: React.FC = () => {
    const { classes } = useStyles();
    const summaries = useMemo(() => orderBy(data, ({ date }) => parseDate(date), 'desc'), []);

    return (
        <Layout>
            <div className={classes.container}>
                <TitleSection title="Changelog" smaller blacken className={classes.title} />
                <div className={classes.cards}>
                    {summaries.map((entry, index) => (
                        <Card key={index} entry={entry} />
                    ))}
                </div>
            </div>
        </Layout>
    );
};

export default Changelog;
